import React from 'react';
import { func, shape } from 'prop-types';
import { Col, Image } from 'react-bootstrap';

import { Text } from 'Component/Ajaib';
import { PopUpCenter } from 'Component/PopUp';
import { noop } from '@ajaibid/utils';
import stylesGlobal from '@screens/style';
import { Button } from '@ajaibid/components';

const PopupDetail = ({ infoPrimeData, hideModal }) => {
  return (
    <PopUpCenter show={infoPrimeData.isOpen} onHide={hideModal} title="">
      <Col className="p-0 text-center" style={stylesGlobal.dGrid}>
        <div className="text-center">
          <Image
            style={{
              maxWidth: infoPrimeData.title ? '360px' : '100%',
              borderRadius: 8,
            }}
            src={infoPrimeData.img}
          />
        </div>
        <Text size="title" className="mt-16 text-body-bold">
          {infoPrimeData.title}
        </Text>
        <Text className="mt-16">{infoPrimeData.content}</Text>
        <Button variant="primary" className="mt-16" onClick={() => hideModal()}>
          Mengerti
        </Button>
      </Col>
    </PopUpCenter>
  );
};

PopupDetail.propTypes = {
  infoPrimeData: shape({}),
  hideModal: func,
};

PopupDetail.defaultProps = {
  infoPrimeData: {},
  hideModal: noop,
};

export default PopupDetail;
